import { useContext, useState, useEffect } from 'react'
import moment from 'moment-timezone'

import { UserContext } from '../context'

export function useUserTimezone() {
  // Get timezone for tooltip
  const { timezones, retrieveTimezones, currentUser } = useContext(UserContext)
  const [tz, setTZ] = useState<string>('')

  const reCalculateTime = () => {
    let calculatedTZ = ''
    if (currentUser && currentUser.time_zone) {
      calculatedTZ = currentUser.time_zone
    } else {
      calculatedTZ = moment.tz.guess()
    }
    const offset = moment.tz(calculatedTZ).format('Z')
    if (timezones) {
      const timezoneName = timezones.find((t) => t.name === calculatedTZ)
      const tooltipHeader = timezoneName
        ? `(GMT ${offset}) ${timezoneName.display}`
        : `(GMT ${offset})`
      setTZ(tooltipHeader)
    }
  }

  useEffect(() => {
    if (!timezones) {
      retrieveTimezones()
    }
    reCalculateTime()
  }, [])

  useEffect(() => {
    reCalculateTime()
  }, [currentUser])
  return tz
}
